module.exports = __webpack_public_path__ + "media/images/icon-signature-0f860b81.svg";